module.exports = __webpack_public_path__ + "static/media/apifm.12e8331b.md";